import { useState } from "react";
import { faqs } from "@/mocks/maydayContent";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="wenda" className="scroll-mt-24 w-full bg-background-100/50">
      <div className="mx-auto w-full max-w-[1000px] px-4 md:px-6 py-12 md:py-16">
        <div className="text-center">
          <div className="text-xs font-medium tracking-widest text-primary-600 mb-2">HOT QUESTIONS</div>
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">热点问答</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            关于假期安排、调休、景区出行与消费维权的高频疑问，一文说清。
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div key={f.q} className={i !== 0 ? "border-t border-background-200/60" : ""}>
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                >
                  <span className="flex items-center gap-3">
                    <span className="font-heading text-lg font-bold text-primary-600">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-base font-medium text-foreground-900">{f.q}</span>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform ${isOpen ? "rotate-180 text-primary-600" : ""}`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-72" : "max-h-0"}`}
                >
                  <p className="px-5 pb-5 pl-[54px] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[54px]">
                    {f.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}